import React from 'react';
import {
  FDAlert, FDImage, FDStack, Paper,
} from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';

const MainContent = () => {
  const { resource } = useMetaLayoutContext();

  const imageWidth = '180px';
  const imageHeight = '45px';

  return (
    <FDStack direction={'column'} alignItems={'center'} justifyContent={'center'}>
      <Paper appearance={'elevated'}>
        <FDStack direction={'column'} justifyContent={'center'} spacing={3} paddingX={4} paddingY={3}>
          {resource.withRelationship(fr.relationships.mainContentImage.name,
            (rel) => (
              <FDImage alt={'main-content-image'} alignSelf={'center'} width={imageWidth} height={imageHeight} src={rel.link('related').url()} />
            ),
            () => null)}
          <MetaField attr="mainContentTitle" />
          <MetaField attr="mainContentDetails" />
          {resource.attr('infoMessage') ? <FDAlert description={resource.attr('infoMessage')} /> : null}
        </FDStack>
      </Paper>
    </FDStack>
  );
};

MainContent.defaultProps = {
};

MainContent.propTypes = {
};

export default MainContent;
